export default __webpack_public_path__ + "static/media/339.f77cccc9.jpg";